import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';
import { skipToastOnErrorContext } from '@core/context/skip-toast-on-error.context';

@Injectable()
export class UserManagementApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public users(
    unitId: ID,
    offset: number,
    limit: number,
    isUserActive: boolean
  ): Observable<PaginatedResponseDAO<UserDAO>> {
    const params = new HttpParams({
      fromObject: { offset, limit, status: isUserActive ? 'Active' : 'Archived' }
    });
    return this.httpClient.get<PaginatedResponseDAO<UserDAO>>(`${this.baseUrl}/units/${unitId}/users`, { params });
  }

  public add(unitId: ID, email: string, role: Role): Observable<UserDAO> {
    const context = new HttpContext();
    context.set(skipToastOnErrorContext, true);
    return this.httpClient.post<UserDAO>(`${this.baseUrl}/units/${unitId}/users`, { email, role }, { context });
  }

  public edit(unitId: ID, userId: ID, model: UserEditDAO): Observable<UserDAO> {
    const context = new HttpContext();
    context.set(skipToastOnErrorContext, true);
    return this.httpClient.patch<UserDAO>(`${this.baseUrl}/units/${unitId}/users/${userId}`, model, { context });
  }

  public remove(unitId: ID, userId: ID): Observable<unknown> {
    return this.httpClient.delete<unknown>(`${this.baseUrl}/units/${unitId}/users/${userId}`);
  }
}
